import React, { useEffect, useState, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CssBaseline from '@mui/material/CssBaseline';
import { motion, AnimatePresence } from 'framer-motion';
import { RecoilRoot, useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';

import { negotiateLanguages } from '@fluent/langneg';
import { FluentBundle, FluentResource } from '@fluent/bundle';
import { LocalizationProvider, ReactLocalization } from '@fluent/react';

// import 'overlayscrollbars/overlayscrollbars.css';
// import {
//   OverlayScrollbars,
//   ScrollbarsHidingPlugin,
//   SizeObserverPlugin,
//   ClickScrollPlugin
// } from 'overlayscrollbars';

import "@fontsource/inter/300.css"; // Specify weight
import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/inter/500.css"; // Specify weight
import "@fontsource/inter/700.css"; // Specify weight
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { getDesignTokens } from './theme';
import { Preloader } from './components/Preloader';
import {
  appearanceState,
  preferedLocalesState,
  availableLocalesState,
} from './state';

import enFtl from './fluent/en.js';
import ruFtl from './fluent/ru.js';

const RESOURCES = {
  'en': new FluentResource(enFtl),
  'ru': new FluentResource(ruFtl),
};

const l10n = new ReactLocalization(generateBundles(navigator.languages));

// A generator function responsible for building the sequence 
// of FluentBundle instances in the order of user's language
// preferences.
function* generateBundles(userLocales) {
  const availableLocales = Object.keys(RESOURCES);
  // Choose locales that are best for the user.
  const currentLocales = negotiateLanguages(
    userLocales,
    availableLocales,
    { defaultLocale: 'en' }
  );

  console.log('currentLocales', currentLocales)

  for (const locale of currentLocales) {
    const bundle = new FluentBundle(locale);
    bundle.addResource(RESOURCES[locale]);
    yield bundle;
  }
}

function Main() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const systemAppearance = prefersDarkMode ? 'dark' : 'light';

  const [appearance, setAppearance] = useRecoilState(appearanceState);
  const [initialized, setInitialized] = useState(false);

  const setAvailableLocales = useSetRecoilState(availableLocalesState);
  const setPreferedLocales = useSetRecoilState(preferedLocalesState);

  useEffect(() => {
    const availableLocales = Object.keys(RESOURCES);
    setAvailableLocales(availableLocales);

    const preferedLocales = negotiateLanguages(
      navigator.languages,
      availableLocales,
      { defaultLocale: 'en' }
    );
    setPreferedLocales(preferedLocales);
  }, [setAvailableLocales, setPreferedLocales]);

  const theme = useMemo(() => {
    const design = getDesignTokens(appearance);
    const resultTheme = createTheme(design);
    // console.log('mui theme', resultTheme);
    return resultTheme;
  }, [appearance]);

  useEffect(() => {
    setAppearance(systemAppearance);
  }, [systemAppearance, setAppearance]);

  useEffect(() => {
    setTimeout(() => {
      setInitialized(true)
    }, 120);
  }, []);

  return (
    // <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider l10n={l10n}>
        <AnimatePresence>
          {!initialized ? (
            <Preloader key="preloader" />
          ) : (
            <App />
          )}
        </AnimatePresence>
      </LocalizationProvider>
    </ThemeProvider>
    // </React.StrictMode>
  );
}

// const osInstance = OverlayScrollbars(document.querySelector('body'), {
//   scrollbars: {
//     theme: 'os-theme-dark', //appearance === 'dark' ? 'os-theme-light' : 'os-theme-dark',
//     // autoHide: 'scroll'
//   }
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RecoilRoot><Main /></RecoilRoot>);

function onTelegramAuth(user) {
  console.log('Logged in as ' + user.first_name + ' ' + user.last_name + ' (' + user.id + (user.username ? ', @' + user.username : '') + ')');
}
window.onTelegramAuth = onTelegramAuth;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
